export default "__VITE_ASSET__5fa0342b__"